module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/产品中心.a67c1654.svg";